(ns ycweb.app.website.keepaside.keepaside
  (:require
   [inflections.core :as inflections]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(defn build-selected-variations-uuids [selected-variations]
  (when selected-variations
    (->>
      selected-variations
      (filter #(second %))
      (map first)
      (vec)
      (not-empty))))

(defn var-in-stock? [stock-count]
  (> stock-count 0))

(defn select-all-variations [variations]
  (reduce
    (fn [acc [k v]]
      (assoc acc k true))
    {}
    variations))

(rum/defc keep-aside < rum/reactive [app-atom options]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])]
    (when (not-empty (:product/variations product))
      (cond
        (:product/dropship? product)
        [:button
         {:class (u/bem :product-action-button [:find] :button [:secondary :full])
          :type "button"
          :on-click #(grid/open-modal app-atom :web.keepaside/modal-dropship)}
         [:span.product-action-button__text.button__text
          [:i.product-action-button__icon
           {:class (u/bem :icon [:location :is-dark :default :block])}]
          [:span.product-action-button__label "Online exclusive"]]
         [:span.product-action-button__float-label
          {:aria-hidden "true"}
          "Stores"]]

        :else
        [:button.ka-button
         {:class (u/bem :product-action-button [:find] :button [:secondary :full])
          :type "button"
          :on-click #(grid/dispatch-action app-atom :web.keepaside/start {})}
         [:span.product-action-button__text.button__text
          [:i.product-action-button__icon
           {:class (u/bem :icon [:location :is-dark :default :block])}]
          [:span.product-action-button__label "Find in store"]]
         [:span.product-action-button__float-label
          {:aria-hidden "true"}
          "Stores"]]))))

(defmethod flow/render-screen :web.keepaside [app-atom _]
  (let [params (get-in @app-atom [:page :web.keepaside :params])]
    (when (:product-uuid params)
      (comms/ajax-get :web.keepaside/list-variations {:content-uuid (:product-uuid params)})
      (keep-aside app-atom {}))))

(defmethod grid/action :web.keepaside/start [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        product (get-in @action-atom [:keepaside-product])]
    (swap! (cmn/action-cursor app-atom) assoc
      :selected-store nil
      :keep-aside nil
      :keepaside-product product
      :variation-choice {:choice "specific"}
      :selected-variations
      (if (:product/single-variation? product)
        (select-all-variations (:product/variations product))
        nil))

    (if (:product/single-variation? product)
      (grid/dispatch-action app-atom :web.keepaside/list-stores {})
      (grid/open-modal app-atom :web.keepaside/modal-step-1))))

(defmethod comms/receive :web.keepaside/list-variations [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :selected-store nil
    :keep-aside nil
    :keepaside-product (:product e)
    :variation-choice {:choice "specific"}
    :selected-variations
    (if (:product/single-variation? (:product e))
      (select-all-variations (:product/variations (:product e)))
      nil)))

;; Dropship Modal ======================================================================================================
(rum/defc modal-dropship-body [app-atom]
  [:div
   (headings/heading "Only available online"
     {:type :h2
      :size :default})
   [:p.yc-paragraph
    "This product is only available for sale online, because it's shipped directly from our supplier.
     We do this when items are very big and heavy or require specialist handling.
     We don't stock these items in our retail stores."]])

(rum/defc modal-dropship-footer [app-atom]
  [:div
   {:class (u/bem :flex-grid-group [:flush])}
   [:div
    {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
    (buttons/button-web "Okay"
      {:type :button
       :on-click #(grid/close-modal app-atom)
       :style :primary
       :size :large
       :full true
       :persistent true
       :flat-style :flat})]

   [:div
    {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
    (buttons/button-web "Close"
      {:type :button
       :on-click #(grid/close-modal app-atom)
       :style :secondary-noborder
       :size :large
       :full true
       :persistent true
       :flat-style :flat})]])

(defmethod grid/modal-config :web.keepaside/modal-dropship [_ _ _]
  {:body modal-dropship-body
   :footer modal-dropship-footer
   :modal-type :variable})

;; STEP 1 - Variation Radio ============================================================================================
(rum/defc modal-step-1-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        variation-choice-atom (rum/cursor-in action-atom [:variation-choice])
        product (cmn/curact action-atom [:keepaside-product])]

    [:div
     (headings/heading "Check store availability" {:type :h2 :size :default})
     [:p.yc-paragraph [:b (:ent/display-name product)]]
     [:p.yc-paragraph "Which variations are you looking for?"]
     [:div.form-field
      (forms/radio (str "All " (inflections/plural (:product/feature-type product))) "all" (rum/cursor variation-choice-atom :choice))]
     [:div.form-field
      (forms/radio (str "Specific " (inflections/plural (:product/feature-type product))) "specific" (rum/cursor variation-choice-atom :choice))]]))

(rum/defc modal-step-1-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        variation-choice (cmn/curact action-atom [:variation-choice :choice])]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      [:div
       {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Next"
         {:type :button
          :on-click
          (fn []
            (cond
              (= variation-choice "specific")
              (do
                (grid/close-modal app-atom)
                (grid/open-modal app-atom :web.keepaside/modal-step-2))

              :else
              (grid/dispatch-action app-atom :web.keepaside/list-stores {})))
          :style :primary
          :size :large
          :full true
          :icon :arrow-right
          :icon-placement :right
          :persistent true
          :flat-style :flat})]

      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Cancel"
         {:type :button
          :on-click
          (fn []
            (grid/close-modal app-atom))
          :style :secondary-noborder
          :size :large
          :full true
          :persistent true
          :flat-style :flat})]]
     (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-1 [app-atom config _]
  {:body modal-step-1-body
   :footer modal-step-1-footer
   :modal-type :variable})

;; STEP 2 - Specific Variation Select ==================================================================================
(rum/defc modal-step-2-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        selected-variations-atom (rum/cursor-in action-atom [:selected-variations])
        product (cmn/curact action-atom [:keepaside-product])
        variations (cmn/curact action-atom [:keepaside-product :product/variations])]

    [:div
     (headings/heading "Check store availability"
       {:type :h2
        :size :default})
     [:p.yc-paragraph [:b (:ent/display-name product)]]
     [:p.yc-paragraph (str "Choose the " (inflections/plural (:product/feature-type product)) " you're looking for")]

     [:div.u-margin-bottom-16
      (map
        (fn [[_ variation]]
          (rum/with-key
            (forms/checkbox-variation-picker
              (rum/cursor-in selected-variations-atom [(:ent/uuid variation)])
              {:name (str (:ent/uuid variation))
               :colour (u/presence (:variation/colour variation))
               :description (:ent/display-name variation)})
            (str (:ent/uuid variation))))
        variations)]]))

(rum/defc modal-step-2-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        selected-variations (cmn/curact action-atom [:selected-variations])]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      [:div
       {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Next"
         {:type :button
          :on-click #(grid/dispatch-action app-atom :web.keepaside/list-stores {})
          :style :primary
          :size :large
          :disabled (empty? (build-selected-variations-uuids selected-variations))
          :full true
          :icon :arrow-right
          :icon-placement :right
          :persistent true
          :flat-style :flat})]

      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Back"
         {:type :button
          :on-click
          (fn []
            (grid/close-modal app-atom)
            (grid/open-modal app-atom :web.keepaside/modal-step-1))
          :style :secondary-noborder
          :size :large
          :full true
          :icon :arrow-left
          :persistent true
          :flat-style :flat})]]
     (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-2 [_ _ _]
  {:body modal-step-2-body
   :footer modal-step-2-footer
   :modal-type :variable})

;; STEP 3 - City, Store Select =========================================================================================
(defmethod grid/action :web.keepaside/list-stores [app-atom config _]
  (toaster/open-overlay app-atom :web.keepaside/submit-overlay)
  (comms/ajax-get :web.keepaside/list-stores config))

(defmethod comms/receive :web.keepaside/list-stores [app-atom e]
  (let [action-atom (cmn/action-cursor app-atom)
        variations (get-in @action-atom [:keepaside-product :product/variations])
        variation-choice (get-in @action-atom [:variation-choice :choice])
        all-variations (select-all-variations variations)]

    (swap! (cmn/action-cursor app-atom) assoc
      :stores (:stores e)
      :selected-variations
      (if (= variation-choice "all")
        all-variations
        (get-in @action-atom [:selected-variations])))

    (grid/close-modal app-atom)
    (grid/open-modal app-atom :web.keepaside/modal-step-3)
    (toaster/close-overlay app-atom :web.keepaside/submit-overlay)))

(rum/defc modal-step-3-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        selected-city-atom (rum/cursor-in action-atom [:selected-store :city])
        selected-city (rum/react selected-city-atom)
        selected-store-atom (rum/cursor-in action-atom [:selected-store :store])
        stores (group-by :store/city (cmn/curact action-atom [:stores]))
        product (cmn/curact action-atom [:keepaside-product])
        variation-choice (cmn/curact action-atom [:variation-choice :choice])
        selected-variations-uuids (build-selected-variations-uuids (cmn/curact action-atom [:selected-variations]))]

    [:div
     (headings/heading "Check store availability"
       {:type :h2
        :size :default})

     [:p.yc-paragraph [:b (:ent/display-name product)]]
     (cond
       (:product/single-variation? product)
       [:p.yc-paragraph (str "Find this product in your nearest store")]

       (= 1 (count selected-variations-uuids))
       [:p.yc-paragraph
        (str "Find the "
          (:ent/display-name (get (:product/variations product) (first selected-variations-uuids)))
          " one in your nearest store")]

       (= variation-choice "all")
       [:p.yc-paragraph (str "Find all " (inflections/plural (:product/feature-type product)) " in your nearest store")]

       :else
       [:p.yc-paragraph (str "Find selected " (inflections/plural (:product/feature-type product)) " in your nearest store")])

     [:div.u-max-width-320
      (forms/select "City:" selected-city-atom
        (into
          [{:text "Select"
            :value ""}]
          (map
            (fn [city]
              {:text city
               :value city})
            (sort (keys stores)))))]

     [:div.u-max-width-320
      (forms/select "Store:" selected-store-atom
        (into
          [{:text "All Stores"
            :value "all-stores"}]
          (map
            (fn [store]
              {:text (:ent/display-name store)
               :value (:ent/uuid store)})
            (sort-by :ent/display-name (get stores selected-city))))
        {:disabled (not (u/presence selected-city))
         :default "all-stores"})]]))

(rum/defc modal-step-3-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        variation-choice (cmn/curact action-atom [:variation-choice :choice])
        selected-city (cmn/curact action-atom [:selected-store :city])]

    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      [:div
       {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Next"
         {:type :button
          :on-click #(grid/dispatch-action app-atom :web.keepaside/list-store-stock {})
          :style :primary
          :size :large
          :disabled (not (u/presence selected-city))
          :full true
          :icon :arrow-right
          :icon-placement :right
          :persistent true
          :flat-style :flat})]

      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (cond
         (:product/single-variation? product)
         (buttons/button-web "Cancel"
           {:type :button
            :on-click
            (fn []
              (grid/close-modal app-atom))
            :style :secondary-noborder
            :size :large
            :full true
            :persistent true
            :flat-style :flat})

         :else
         (buttons/button-web "Back"
           {:type :button
            :on-click
            (fn []
              (grid/close-modal app-atom)
              (if (= variation-choice "specific")
                (grid/open-modal app-atom :web.keepaside/modal-step-2)
                (grid/open-modal app-atom :web.keepaside/modal-step-1)))
            :style :secondary-noborder
            :size :large
            :full true
            :icon :arrow-left
            :persistent true
            :flat-style :flat}))]]
     (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-3 [_ _ _]
  {:body modal-step-3-body
   :footer modal-step-3-footer
   :modal-type :variable})

;; STEP 4 - Show Store Stock ===========================================================================================
(defmethod grid/action :web.keepaside/list-store-stock [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        selected-stores-atom (rum/cursor-in action-atom [:selected-store])
        selected-variations-atom (rum/cursor-in action-atom [:selected-variations])
        selected-variations (build-selected-variations-uuids @selected-variations-atom)]

    (toaster/open-overlay app-atom :web.keepaside/submit-overlay)
    (comms/ajax-post :web.keepaside/store-availability
      (u/maybe assoc
        {:city {:ent/display-name (:city @selected-stores-atom)}
         :variation-uuids selected-variations}
        :store
        (when-not (= "all-stores" (:store @selected-stores-atom))
          {:ent/uuid (:store @selected-stores-atom)})))))

(defmethod comms/receive :web.keepaside/store-availability [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :selected-store-stock (:selected-store-stock e)
    :user (:user e))

  (grid/close-modal app-atom)
  (grid/open-modal app-atom :web.keepaside/modal-step-4)
  (toaster/close-overlay app-atom :web.keepaside/submit-overlay))

(defn stock-message [warehouse-only? in-stock?]
  (cond
    (and in-stock? warehouse-only?)
    "In warehouse"

    in-stock?
    "In stock"

    :else
    "Out of stock"))

(rum/defc stock-card < rum/reactive
  [app-atom
   {:ent/keys [display-name]
    :store/keys [address maps-link stock]
    :as store}]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        selected-variations (build-selected-variations-uuids (cmn/curact action-atom [:selected-variations]))
        {:user/keys [logged-in?]} (cmn/curact action-atom [:user])

        has-stock?
        (reduce
          (fn [acc v]
            (if (> (:variation/store-stock (get (:store/stock store) v)) 0)
              true
              acc))
          false
          selected-variations)

        has-warehouse-only?
        (reduce
          (fn [acc v]
            (if (:variation/warehouse-only? (get (:store/stock store) v))
              true
              acc))
          false
          selected-variations)]

    [:article.store-stock-card
     {:class (u/bem :card [:no-hover])}

     [:header.store-stock-card__header
      [:h3.store-stock-card__title display-name]]

     (cond
       (:product/single-variation? product)
       (let [variation-detail
             (->>
               selected-variations
               (first)
               (get stock))

             in-stock?
             (->>
               variation-detail
               (:variation/store-stock)
               (var-in-stock?))

             warehouse-only? (:variation/warehouse-only? variation-detail)]
         [:p.store-stock-card__status
          [:i.store-stock-card__icon
           {:class
            (u/bem :icon
              [(cond
                 warehouse-only?
                 :success-orange

                 in-stock?
                 :success-green

                 :else
                 :error-red)
               :in-copy-left :small :inline])}]
          [:b
           {:class
            (u/bem :text-status
              [(cond
                 warehouse-only?
                 :warning

                 in-stock?
                 :success

                 :else
                 :error)])}
           (stock-message warehouse-only? in-stock?)]])

       (= "colour" (:product/feature-type product))
       (into
         [:ul.store-stock-card-list]
         (map
           (fn [vuuid]
             (let [{:variation/keys [store-stock warehouse-only?]} (get stock vuuid)
                   variation (get (:product/variations product) vuuid)
                   in-stock? (var-in-stock? store-stock)]
               [:li.store-stock-card-list__item
                [:div.store-stock-card-list__content
                 [:div.store-stock-card-list__colour
                  {:style {:background-color (str "#" (:variation/colour variation))}}]
                 [:div.store-stock-card-list__details
                  [:div.store-stock-card-list__name (:ent/display-name variation)]
                  [:div.store-stock-card-list__status
                   [:i.store-stock-card__icon
                    {:class
                     (u/bem :icon
                       [(cond
                          warehouse-only?
                          :success-orange

                          in-stock?
                          :success-green

                          :else
                          :error-red) :in-copy-left :small :inline])}]
                   [:b
                    {:class
                     (u/bem :text-status
                       [(cond
                          warehouse-only?
                          :warning

                          in-stock?
                          :success

                          :else
                          :error)])}
                    (stock-message warehouse-only? in-stock?)]]]]]))
           selected-variations))

       :else
       (into
         [:ul.store-stock-card-list]
         (map
           (fn [vuuid]
             (let [{:variation/keys [store-stock warehouse-only?]} (get stock vuuid)
                   variation (get (:product/variations product) vuuid)
                   in-stock? (var-in-stock? store-stock)]
               [:li.store-stock-card-list__item
                [:div.store-stock-card-list__details
                 [:div.store-stock-card-list__name
                  [:b (:ent/display-name variation)]]
                 [:div.store-stock-card-list__status
                  [:i.store-stock-card__icon
                   {:class
                    (u/bem :icon
                      [(cond
                         warehouse-only?
                         :success-orange

                         in-stock?
                         :success-green

                         :else
                         :error-red) :in-copy-left :small :inline])}]
                  [:b
                   {:class
                    (u/bem :text-status
                      [(cond
                         warehouse-only?
                         :warning

                         in-stock?
                         :success

                         :else
                         :error)])}
                   (stock-message warehouse-only? in-stock?)]]]]))
           selected-variations)))

     [:div.store-stock-card__details
      [:p {:class (u/bem :yc-paragraph [:small (when has-warehouse-only? :flush)])}
       address ". "
       [:a.text-link {:href maps-link :target "_blank"} "Directions"]]

      (when has-warehouse-only?
        ;;TODO — This needs to be changed to a default CLJ feedback component
        [:div.u-margin-top-16
         {:class (u/bem :feedback [:out-of-online-stock :small :flush])}
         [:div.feedback__icon [:i {:class (u/bem :icon [:info :block])}]]
         [:div.feedback__content
          [:b "Note:"]
          " Stock from our warehouse can take up to one business day to move to our Westlake store. We'll notify you when it's ready."]])

      ;;todo - we don't have this available in clojure (currently sitting in smarty.php) - add this in once we have it in the database
      #_[:p
         {:class (u/bem :yc-paragraph [:flush :small])}
         "Open until: " (:trading-hours-end store)]]

     (when logged-in?
       [:footer.store-stock-card__footer
        {:class (u/bem :flex-grid-group [:valign-middle :flush])}
        [:div
         {:class (u/bem :flex-grid-block [:t-1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button-web "Directions"
            {:href maps-link
             :target "_blank"
             :style :secondary-noborder
             :size :default
             :flat-style :flat-to-raised
             :full true
             :persistent true
             :icon :location})]]

        [:div
         {:class (u/bem :flex-grid-block [:t-1-2 :flush])}
         [:div.flex-grid-content
          (buttons/button-web "Keep aside"
            {:type :button
             :on-click
             #(grid/dispatch-action app-atom :web.keepaside/select-store {:store {:ent/uuid (:ent/uuid store)}})
             :style :primary
             :size :default
             :full true
             :disabled (not has-stock?)
             :flat-style :flat-to-raised
             :persistent true
             :icon :shopping-bag})]]])]))

(rum/defc modal-step-4-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        {:user/keys [logged-in?]} (cmn/curact action-atom [:user])
        stores (u/index-by :ent/uuid (cmn/curact action-atom [:stores]))
        selected-store-stock (cmn/curact action-atom [:selected-store-stock])
        selected-city (cmn/curact action-atom [:selected-store :city])
        selected-store (cmn/curact action-atom [:selected-store :store])
        variation-choice (cmn/curact action-atom [:variation-choice :choice])
        selected-variations-uuids (build-selected-variations-uuids (cmn/curact action-atom [:selected-variations]))

        store-text
        (if (= "all-stores" selected-store)
          (str " for all " selected-city " stores")
          (str " in " (:ent/display-name (get stores (u/uuid selected-store)))))]

    [:<>
     (headings/heading "Check store availability" {:type :h2 :size :default})
     [:p
      {:class (u/bem :yc-paragraph [:flush])}
      [:b (:ent/display-name product)]]

     (cond
       (:product/single-variation? product)
       [:p.yc-paragraph (str "Showing this product" store-text)]

       (= 1 (count selected-variations-uuids))
       [:p.yc-paragraph
        (str "Showing the " (:ent/display-name (get (:product/variations product) (first selected-variations-uuids)))
          " one" store-text)]

       (= variation-choice "all")
       [:p.yc-paragraph (str "Showing all " (inflections/plural (:product/feature-type product)) store-text)]

       :else
       [:p.yc-paragraph (str "Showing selected " (inflections/plural (:product/feature-type product)) store-text)])

     (when (:product/on-special? product)
       (feedback/feedback
         :warning
         "Buying this because it's a great deal today?"
         "The promotion or price might change between now and when you come into the store to buy it. Consider buying it online now and collecting it in-store."))

     (cond
       logged-in?
       [:p.yc-paragraph
        "If the item is in stock in your chosen store, you'll be able to request that it be kept aside, and we'll notify you when it's ready for you to come in to view and buy it. "
        [:a.text-link
         {:href "/help.htm?action=article&id=287"}
         "Learn more about how it works."]]

       :else
       (feedback/feedback
         :info
         "Log in to keep items aside"
         (list
           "You will need to "
           [:a.text-link {:href (str "/login.htm?afterloginredirect=/" (:product/url product))} "log in to your Yuppiechef account"]
           " to request that an item which is in stock in a store be kept aside for you at that store. "
           [:a.text-link
            {:href "/help.htm?action=article&id=287"}
            "Learn more about how it works."])))

     (map
       (fn [store]
         (rum/with-key (stock-card app-atom store) (str (:ent/uuid store))))
       selected-store-stock)]))

(rum/defc modal-step-4-footer [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        {:user/keys [logged-in?]} (cmn/curact action-atom [:user])]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      (cond
        logged-in?
        [:div
         {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}]

        :else
        [:div
         {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
         (buttons/button-web "Log in"
           {:type :button
            :href (str "/login.htm?afterloginredirect=/" (:product/url product))
            :style :primary
            :size :large
            :full true
            :persistent true
            :flat-style :flat})])
      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Back"
         {:type :button
          :on-click
          (fn []
            (grid/close-modal app-atom)
            (grid/open-modal app-atom :web.keepaside/modal-step-3))
          :style :secondary-noborder
          :size :large
          :full true
          :icon :arrow-left
          :persistent true
          :flat-style :flat})]]
          (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-4 [_ _ _]
  {:body modal-step-4-body
   :footer modal-step-4-footer
   :modal-type :variable})

;; STEP 5 - Keep Aside quantities ======================================================================================
(defmethod grid/action :web.keepaside/select-store [app-atom {:keys [store]} _]
  (toaster/open-overlay app-atom :web.keepaside/submit-overlay)
  (swap! (cmn/action-cursor app-atom) assoc-in
    [:keep-aside :store :ent/uuid] (:ent/uuid store))
  (comms/ajax-get :web.keepaside/user-details {}))

(defmethod comms/receive :web.keepaside/user-details [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc-in
    [:keep-aside :user] (:user e))

  (grid/close-modal app-atom)
  (grid/open-modal app-atom :web.keepaside/modal-step-5)
  (toaster/close-overlay app-atom :web.keepaside/submit-overlay))

(rum/defc modal-step-5-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        selected-variations-atom (rum/cursor-in action-atom [:selected-variations])

        selected-store-stock-atom (rum/cursor-in action-atom [:selected-store-stock])
        selected-store-stock
        (->>
          (rum/react selected-store-stock-atom)
          (u/index-by :ent/uuid))

        store (get selected-store-stock (cmn/curact action-atom [:keep-aside :store :ent/uuid]))

        selected-variations
        (->>
          (rum/react selected-variations-atom)
          (filter #(second %))
          (map first))]
    [:div
     (headings/heading (str "Keep aside in Yuppiechef " (:ent/display-name store))
       {:type :h2
        :size :default})

     [:p.yc-paragraph [:b (:ent/display-name product)]]
     (when-not (:product/single-variation? product)
       [:p.yc-paragraph "How many would you like us to keep aside?"])
     (into
       [:ul.store-stock-card-list]
       (map
         (fn [vuuid]
           (let [{:variation/keys [store-stock]} (get (:store/stock store) vuuid)
                 variation (get (:product/variations product) vuuid)
                 in-stock? (var-in-stock? store-stock)]
             (when in-stock?
               [:li.store-stock-card-list__item
                [:div.store-stock-card-list__content
                 (when (= "colour" (:product/feature-type product))
                   [:div.store-stock-card-list__colour
                    {:style {:background-color (str "#" (:variation/colour variation))}}])
                 [:div.store-stock-card-list__details
                  [:div.store-stock-card-list__name
                   (if (:product/single-variation? product)
                     "How many would you like us to keep aside?"
                     (:ent/display-name variation))]]]
                [:div.store-stock-card-list__qty
                 (forms/select-raw
                   (rum/cursor (rum/cursor-in action-atom [:keep-aside :variations vuuid]) :variation/qty)
                   (into
                     [{:text "0"
                       :value 0}]
                     (for [x (range 1 (min (+ store-stock 1) 11))]
                       {:value x :text x}))
                   {:inline? true
                    :default (if (> (count selected-variations) 1) 0 1)})]])))
         selected-variations))]))

(defmethod grid/action :web.keepaside/validate-quantities [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        current-store (:ent/uuid (:store (:keep-aside @action-atom)))
        selected-stores-idx
        (->>
          (:selected-store-stock @action-atom)
          (u/index-by :ent/uuid))

        store-stock (:store/stock (get selected-stores-idx current-store))
        variations (:variations (:keep-aside @action-atom))

        variations-over-ordered
        (not-empty
          (filter
            (fn [[vuuid v]] (> (:variation/qty v) (:variation/store-stock (get store-stock vuuid))))
            variations))]

    (when-not variations-over-ordered
      (grid/close-modal app-atom)
      (grid/open-modal app-atom :web.keepaside/modal-step-6))))

(rum/defc modal-step-5-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        item-count
        (rum/react
          (rum/derived-atom [action-atom] ::modal-step-5
            (fn [a]
              (->>
                (get-in a [:keep-aside :variations])
                (vals)
                (map (comp trf/tonumber :variation/qty))
                (reduce + 0)))))]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}
      [:div
       {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Next"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom :web.keepaside/validate-quantities {})
          :style :primary
          :size :large
          :full true
          :disabled (= item-count 0)
          :icon :arrow-right
          :icon-placement :right
          :persistent true
          :flat-style :flat})]
      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Back"
         {:type :button
          :on-click
          (fn []
            (grid/close-modal app-atom)
            (grid/open-modal app-atom :web.keepaside/modal-step-4))
          :style :secondary-noborder
          :size :large
          :full true
          :icon :arrow-left
          :persistent true
          :flat-style :flat})]]
     (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-5 [_ _ _]
  {:body modal-step-5-body
   :footer modal-step-5-footer
   :modal-type :variable})

;; STEP 6 - Customer Details ===========================================================================================
(rum/defc modal-step-6-body < rum/reactive [app-atom _ m-config]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        selected-variations-uuids (build-selected-variations-uuids (cmn/curact action-atom [:selected-variations]))
        selected-store-stock-atom (rum/cursor-in action-atom [:selected-store-stock])
        selected-store-stock
        (->>
          (rum/react selected-store-stock-atom)
          (u/index-by :ent/uuid))

        keep-aside-atom (rum/cursor-in action-atom [:keep-aside])
        newsletter-atom (rum/cursor-in keep-aside-atom [:user :user/subscribe-newsletter])
        newsletter-selected (rum/react newsletter-atom)
        store (get selected-store-stock (cmn/curact action-atom [:keep-aside :store :ent/uuid]))]

    [:div
     (headings/heading (str "Keep aside in Yuppiechef " (:ent/display-name store))
       {:type :h2
        :size :default})
     [:p.yc-paragraph [:b (:ent/display-name product)]]

     (cond
       (:product/single-variation? product)
       [:p.yc-paragraph (str "Fill in your details so that we can keep aside this product for you.")]

       (= 1 (count selected-variations-uuids))
       [:p.yc-paragraph (str "Fill in your details so that we can keep aside this " (:product/feature-type product) " for you.")]

       :else
       [:p.yc-paragraph (str "Fill in your details so that we can keep aside your selected " (inflections/plural (:product/feature-type product)) " for you.")])

     [:form.u-max-width-480
      {:ref (fn [node] (reset! (:node-atom m-config) node))}
      (forms/split-input-field
        ["First name: (required)" "e.g. Jane"
         (rum/cursor-in keep-aside-atom [:user :user/firstname])
         {:type :user :id :first-name :name :firstname :required? true}]
        ["Last name: (required)" "e.g. Smith"
         (rum/cursor-in keep-aside-atom [:user :user/lastname])
         {:type :user :id :last-name :name :lastname :required? true}])

      (forms/input
        "Email address: (required)" "e.g. jane.smith@domain.com"
        (rum/cursor-in keep-aside-atom [:user :user/email])
        {:type :email
         :id :email
         :name :email
         :required? true})
      (forms/input
        "Contact number: (required)" "e.g. 083 000 0000"
        (rum/cursor-in keep-aside-atom [:user :user/telephone])
        {:type :phone
         :id :tel
         :name :telephone
         :required? true})

      [:div.form-field.toggle-label
       [:label.form-field.toggle-label
        [:input.toggle
         (forms/checkbox-props
           newsletter-atom
           #(swap! keep-aside-atom assoc-in [:user :user/subscribe-promotions] @newsletter-atom)
           nil
           false
           false)]
        [:span.toggle__graphic-wrapper
         [:span.toggle__graphic]]
        [:span.toggle__text
         [:span.toggle__title "Newsletters and personalised offers"]
         [:span "Find out first about new launches and deals, plus the chance to receive occasional vouchers"]]]]

      [:div.form-field.toggle-label
       [:label.form-field.toggle-label
        [:input.toggle
         (forms/checkbox-props
           (rum/cursor-in keep-aside-atom [:user :user/subscribe-promotions])
           nil
           nil
           newsletter-selected
           false)]
        [:span.toggle__graphic-wrapper
         [:span.toggle__graphic]]
        [:span.toggle__text
         [:span.toggle__title "Personalised offers only"]
         [:span "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"]]]]]]))

(defn keep-aside-submit-disabled? [{:keys [user]}]
  (not
    (and (u/presence (:user/firstname user)) (u/presence (:user/lastname user)) (u/presence (:user/email user))
      (u/presence (:user/telephone user)))))

(rum/defc modal-step-6-footer < rum/reactive [app-atom _ m-config]
  (let [keep-aside-data (cmn/curact (cmn/action-cursor app-atom) [:keep-aside])]
    [:div
     [:div
      {:class (u/bem :flex-grid-group [:flush])}

      [:div
       {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Submit"
         {:type :button
          :on-click
          (forms/form-validate (:node-atom m-config)
            #(grid/dispatch-action app-atom :web.keepaside/submit-keep-aside {}))
          :style :primary
          :size :large
          :disabled (keep-aside-submit-disabled? keep-aside-data)
          :full true
          :persistent true
          :flat-style :flat})]
      [:div
       {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Back"
         {:type :button
          :on-click
          (fn []
            (grid/close-modal app-atom)
            (grid/open-modal app-atom :web.keepaside/modal-step-5))
          :style :secondary-noborder
          :size :large
          :full true
          :icon :arrow-left
          :persistent true
          :flat-style :flat})]]
     (toaster/loading-overlay app-atom :web.keepaside/submit-overlay)]))

(defmethod grid/modal-config :web.keepaside/modal-step-6 [_ _ _]
  {:body modal-step-6-body
   :footer modal-step-6-footer
   :node-atom (atom nil)
   :modal-type :variable})

;; STEP 7 - Request Received ===========================================================================================
(defmethod grid/action :web.keepaside/submit-keep-aside [app-atom _ _]
  (let [{:keys [store variations user]} (cmn/curact (cmn/action-cursor app-atom) [:keep-aside])]
    (toaster/open-overlay app-atom :web.keepaside/submit-overlay)
    (comms/ajax-post :web.keepaside/submit-keep-aside
      {:store store
       :variations variations
       :user user})))

(defmethod comms/receive :web.keepaside/submit-keep-aside [app-atom e]
  (grid/close-modal app-atom)
  (grid/open-modal app-atom :web.keepaside/modal-step-7)
  (toaster/close-overlay app-atom :web.keepaside/submit-overlay))

(rum/defc modal-step-7-body < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        product (cmn/curact action-atom [:keepaside-product])
        keep-aside-data (cmn/curact action-atom [:keep-aside])

        selected-store-stock-atom (rum/cursor-in action-atom [:selected-store-stock])
        selected-store-stock
        (->>
          (rum/react selected-store-stock-atom)
          (u/index-by :ent/uuid))
        store (get selected-store-stock (:ent/uuid (:store keep-aside-data)))

        product-text
        (cond
          (:product/single-variation? product)
          (str "the " (:ent/display-name product))

          (= 1 (count (:variations keep-aside-data)))
          (str "the " (:ent/display-name (get (:product/variations product) (ffirst (:variations keep-aside-data)))) " " (:ent/display-name product))

          :else
          (str "the selected " (:ent/display-name product) " " (inflections/plural (:product/feature-type product))))

        item-count (reduce + (map #(trf/tonumber (:variation/qty %)) (vals (:variations keep-aside-data))))

        item-plural? (> item-count 1)]
    [:div
     (headings/heading "Request received"
       {:type :h2
        :size :default})

     [:p.yc-paragraph
      "Thank you. We've received your request to keep aside " product-text " for you in our "
      [:a.text-link {:href (:store/maps-link store) :target "_blank"} (:ent/display-name store) " store"] "."]

     [:p.yc-paragraph
      "We'll send you an email to let you know once we've set aside the " (if item-plural? "items" "item") " for you and "
      (if item-plural? "they're" "it's") " available for you to come in and take a look."]

     (feedback/feedback
       :info "Please wait for confirmation email"
       (str "The " (if item-plural? "items" "item") " will only be ready once you've received this confirmation email from us.
          Please show the email to any store assistant and they'll be able to help you."))]))

(rum/defc modal-step-7-footer [app-atom]
  [:div
   {:class (u/bem :flex-grid-group [:flush])}
   [:div
    {:class (u/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
    (buttons/button-web "Done"
      {:type :button
       :on-click
       (fn []
         (grid/close-modal app-atom))
       :style :primary
       :size :large
       :full true
       :persistent true
       :flat-style :flat})]
   [:div
    {:class (u/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
    (buttons/button-web "Return to homepage"
      {:href "/index.htm"
       :style :secondary-noborder
       :size :large
       :full true
       :icon :arrow-left
       :persistent true
       :flat-style :flat})]])

(defmethod grid/modal-config :web.keepaside/modal-step-7 [_ _ _]
  {:body modal-step-7-body
   :footer modal-step-7-footer
   :modal-type :variable})
